import Link from '@/components/Link';
import FeatureTile, { FeatureTileProps } from '@/components/_atoms/FeatureTile';
import Heading from '@/components/_atoms/Heading';
import FrontPinkButton from '@/components/buttons/primary/FrontPinkButton';
import { mediaBreakpointUp } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { remCalc } from '@/styles/typography/utils';
import { FC } from 'react';
import styled from 'styled-components';

export interface FeatureTilesProps {
  heading?: string;
  cta?: {
    text: string;
    href: string | URL;
    onClick?: () => void;
  };
  items: FeatureTileProps[];
}

const FeatureTiles: FC<FeatureTilesProps> = (props) => {
  return (
    <FeatureTilesSection>
      {props.heading && (
        <HeadingWrapper>
          <Heading level={1} as="h2" id="feature-tiles-heading">
            {props.heading}
          </Heading>
        </HeadingWrapper>
      )}

      <FeatureGrid>
        {props.items.map((item) => (
          <FeatureTile key={item.text} {...item} />
        ))}
      </FeatureGrid>

      {props.cta ? (
        <CTAWrapper>
          <Link href={props.cta.href}>
            <FrontPinkButton onClick={props.cta.onClick} id="feature-tiles-cta">
              {props.cta.text}
            </FrontPinkButton>
          </Link>
        </CTAWrapper>
      ) : null}
    </FeatureTilesSection>
  );
};

export default FeatureTiles;

// Styled Components
const FeatureTilesSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${remCalc(30, 0)};
  row-gap: ${remCalc(30)};
  width: 100%;

  ${mediaBreakpointUp('desktop')} {
    row-gap: ${remCalc(60)};
  }
`;

const HeadingWrapper = styled.div`
  text-align: center;
`;

const FeatureGrid = styled.div`
  display: grid;
  gap: ${remCalc(20)};
  grid-template-columns: repeat(var(--feature-grid-columns, 2), 1fr);

  ${mediaBreakpointUp('tablet')} {
    grid-template-columns: repeat(var(--feature-grid-columns, 4), 1fr);
  }
`;

const CTAWrapper = styled.div`
  text-align: center;
  margin: 0 auto;

  a {
    font-size: ${remCalc(16)};
    font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  }
`;
